import { Navigate, useParams } from "react-router-dom";

export default function UniversityStudentsIndexPage() {
  const { universityId } = useParams();
  return <Navigate to={`/education/universities/${universityId}/students/current`} replace />;
}
